import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { AuthenticationService } from "@services/authentication.service";
import { CommonService } from '@services/app.common.service';
import { HttpClient } from '@angular/common/http';
import { StatusCode } from '@shared/_enums/Common';
import { FormConfigModel } from '@shared/_models/Layout/FormConfig';
import { RoleAccessService } from '@services/role.access.service';
import { ClienDivisionsSecurityDTO } from '@shared/_models/settings/settingsModels';
import { User } from '../Interface/force-password-change.interface';
import { PwnedPasswordService } from '../../_shared/_services/pwned-password.service';

@Component({
    selector: 'app-force-password-change',
    templateUrl: './forcePasswordChange.component.html',
    styleUrls: ['./forcePasswordChange.component.css'],
    standalone: false
})

export class forcePasswordChangeComponent implements OnInit {
/*  public appValForm: FormGroup;*/
  public submittedApplicationForm = '';
  public user= {} as User ;
  public containPasswor: string='';
  public length: number=0;
  public notValidPattern: string = '';
  public notEquivalent: string = '';
  public password: string = '';
  public confirPassword: string = '';
  public PasswordInstruntion: string = '';
  public modalConfig = {} as  FormConfigModel;
  public paswordComplexity = {} as ClienDivisionsSecurityDTO;
  public error: string = '';
  public showLoader: boolean = false;
  isPasswordBreached: boolean = false;
  data = [];
/*  public _http;*/
  //public _baseUrl;
  public StatusCode = StatusCode;
  //public ssoConfig;
  public isShow = false;
  constructor(public roleService: RoleAccessService, public common: CommonService, public authService: AuthenticationService, public pwnedPasswordService: PwnedPasswordService, http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
  }

  ngOnInit() {

    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
    // this.PasswordInstruntion = this.common.GetTranslation("Login.PasswordInstruntion")
    this.PopulateData();
  }
  public PopulateData() {
    this.common.GetData(this.common.ApiUrls.SystemUser.GetCurrentUserDetail, true).then(data => {
      this.user = data.resultData.currentUser;
      this.paswordComplexity = data.resultData.passwordComplexity;
    });
  }

  public async Save() {

    if (this.common.isNullOrWhiteSpace(this.common.message)) {
      this.common.message = this.common.GetTranslation('Common.passwordContain' + this.paswordComplexity.minLength + 'Common.characters' + this.paswordComplexity.numberLength + 'Common.digits' + this.paswordComplexity.upperLength + 'Common.uppercase' + this.paswordComplexity.specialLength + 'Common.specialcharacter' + this.paswordComplexity.specialChars);
      // this.common.message = `Your password must contain at least ${this.paswordComplexity.minLength} characters, of which a minimum of ${this.paswordComplexity.numberLength} should be digits (0-9), ${this.paswordComplexity.upperLength} upper case character and ${this.paswordComplexity.specialLength} special character. Allowed special character: ${this.paswordComplexity.specialChars}`
    }
    this.isPasswordBreached = false;
    this.isShow = true;
    this.submittedApplicationForm = 'true';
    if (this.user.password) {
      const matchPassword = this.user.password.match('^(?=.*[A-Z])(?=.*[0-9])(?=.*[' + this.paswordComplexity.specialChars + '])(?=.{' + this.paswordComplexity.minLength + ',})');
      const spaces = this.common.CountRegExp(this.user.password, /\s/g);
      let inValidChars = '';
      const allowableSpecilaChars = new RegExp('[' + this.paswordComplexity.specialChars + ']', 'g');
      inValidChars = this.user.password.replace(/[a-z]/gi, '') + inValidChars.replace(/\d/g, '');
      inValidChars = inValidChars.replace(/\d/g, '');
      inValidChars = inValidChars.replace(allowableSpecilaChars, '');
      if (matchPassword == null || spaces > 0 || inValidChars !== '') {
        this.notValidPattern = 'true';
        return;
      } else {
        this.notValidPattern = '';
      }
    } else {
      this.notValidPattern = 'true';
      return;
    }
    if (this.notEquivalent == 'true') {
      return;
    } else {
      this.notEquivalent == '';
    }
    this.user.password = this.user.password;
    this.user.confirmPassword = this.user.confirmPassword;
    this.user.oldPassword = this.user.oldPassword;
    this.user.isOnlyPasswordUpdate = true;

    this.isPasswordBreached = await this.pwnedPasswordService.isPasswordBreached(this.user.password);
    if (this.isPasswordBreached) {
      return;
    }
    else {
      this.common.PostData(this.common.ApiUrls.SystemUser.UpdatePassword, this.user, true).then(data => {
        if (data.status == StatusCode.OK) {
          this.common.Notification.success(this.common.GetTranslation('Login.PasswordChanged'));
          const userInfo = JSON.parse(this.common.GetFromLocalStorage('jt_user_info'));
          userInfo.forcePasswordChange = 'No';
          this.common.SetLocalStorage('jt_user_info', JSON.stringify(userInfo));
          this.common.RemoveLocalStorage('jt_password_compromised');
          let url;
          if (this.roleService.HasAccess('Dashboard', 'Access')) {
            url = this.common.RouteUrls.Home.Home;
          } else {
            url = this.common.RouteUrls.JobandTalent.List;
          }
          this.common.NavigateToRoute(url);
        } else if (data.status == StatusCode.Restricted) {
          this.common.Notification.info(this.common.GetTranslation('Messages.OldPasswordNotMatch'));
        } else {
          this.common.Notification.error(this.common.GetTranslation('Messages.SomeThingWentWrong'));
        }
      });
      this.password = '';
      this.confirPassword = '';
      this.common.message = '';

    }

  }

  public checkIfMatchingPasswords(e:any) {

    const passwordInput = this.user.password,
      passwordConfirmationInput = this.user.confirmPassword;
    if (passwordInput != '') {
      if (passwordInput !== passwordConfirmationInput) {
        this.notEquivalent = 'true';
        this.submittedApplicationForm = 'true';
        this.notValidPattern = 'true';
        return;
      } else {
        this.notEquivalent = '';
        this.notValidPattern = '';
        this.submittedApplicationForm = '';

      }
    } else {
      this.notEquivalent = '';
      this.notValidPattern = '';
      this.submittedApplicationForm = '';

    }
  }
  public strengthChanged() {
    // setTimeout(() => {
    //  this.submittedApplicationForm = "";
    // }, 50);
    this.isShow = false;
    this.common.GetPasswordStrengthInfo(this.user.password, this.paswordComplexity);
  }




}
